{
  "actionbar.actions": "Darbības",
  "actionbar.actionsAvailable": "Pieejamas darbības.",
  "actionbar.clearSelection": "Notīrīt atlasi",
  "actionbar.selected": "{count, plural, =0 {Nav atlasīts nekas} other {Atlasīts(-i): #}}",
  "actionbar.selectedAll": "Atlasīts viss",
  "breadcrumbs.more": "Vairāk vienumu",
  "button.pending": "gaida",
  "calendar.invalidSelection": "Atlasītais(-ie) {selectedCount, plural, one {date} other {dates}} nav pieejams(-i).",
  "combobox.noResults": "Nav rezultātu",
  "contextualhelp.help": "Palīdzība",
  "contextualhelp.info": "Informācija",
  "datepicker.endTime": "Beigu laiks",
  "datepicker.startTime": "Sākuma laiks",
  "datepicker.time": "Laiks",
  "dialog.alert": "Brīdinājums",
  "dialog.dismiss": "Nerādīt",
  "dropzone.replaceMessage": "Lai aizstātu, nometiet failu",
  "inlinealert.informative": "Informācija",
  "inlinealert.negative": "Kļūda",
  "inlinealert.notice": "Brīdinājums",
  "inlinealert.positive": "Izdevās",
  "label.(optional)": "(neobligāti)",
  "label.(required)": "(obligāti)",
  "menu.moreActions": "Citas darbības",
  "notificationbadge.indicatorOnly": "Jauna aktivitāte",
  "notificationbadge.plus": "{notifications}+",
  "picker.placeholder": "Izvēlēties…",
  "picker.selectedCount": "{count, plural, =0 {Nav atlasīts neviens vienums} one {# vienums atlasīts} other {# ieraksti vienumi}}",
  "slider.maximum": "Maksimālā vērtība",
  "slider.minimum": "Minimālā vērtība",
  "table.cancel": "Atcelt",
  "table.editCell": "Rediģēt šūnu",
  "table.loading": "Notiek ielāde...",
  "table.loadingMore": "Tiek ielādēts vēl...",
  "table.resizeColumn": "Mainīt kolonnas lielumu",
  "table.save": "Saglabāt",
  "table.sortAscending": "Kārtot augošā secībā",
  "table.sortDescending": "Kārtot dilstošā secībā",
  "tag.actions": "Darbības",
  "tag.hideButtonLabel": "Rādīt mazāk",
  "tag.noTags": "Nav",
  "tag.showAllButtonLabel": "Rādīt visu ({tagCount, number})",
  "toast.clearAll": "Notīrīt visu",
  "toast.collapse": "Sakļaut",
  "toast.showAll": "Rādīt visu"
}
